export const setTimerWithSavedTime = (savedTimeInMillis: number, setEditionBlocked: any): void => {
  const currentTimeInMillis: number = Date.now();
  const timeDifferenceToThirtyMinutes: number = currentTimeInMillis - savedTimeInMillis;
  console.log('entrou no timeDifferenceToThirtyMinutes: ', timeDifferenceToThirtyMinutes);

  if (timeDifferenceToThirtyMinutes < 1800000) {
    const remainingTime: number = 1800000 - timeDifferenceToThirtyMinutes;
    console.log(' remainingTime: ', remainingTime);
    setTimeout(() => {

      setEditionBlocked(false);
      localStorage.removeItem('block-timer');
    }, remainingTime);

    console.log(`Timer set for ${remainingTime} milliseconds.`);
  } else {
    console.log('The saved time is in the past. No timer set.');
    localStorage.removeItem('block-timer');
  }
};
